import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const WhyUs = () => (
    <Grid className="full">
        <Grid
            container
            xs={12}
            spacing={2}
            directon="row"
            justifyContent="space-around"
            alignItems="center"
        >
            <Grid item lg={5}>
                <Box className="padding" align="center" justify="center">
                    <Box pad="small">
                        <Typography variant="h1" m={1}>
                            Why use airTeachr
                        </Typography>
                        <Typography variant="subtitle2" m={1}>
                            airTeachr was born to enable schools and relief
                            teachers to both have a better experience
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body1">
                            Content coming soon.
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    </Grid>
);

export default WhyUs;
